import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';

import { CUSTOMER_TYPE_TO_ROUTE, FILTERS_NAME } from '../constants/filters';
import type { TFilters } from '../types/filters';
import type { TQuery } from '../types/router';

export const makeQueryParamsFromFilters = (filters: TFilters): TQuery => {
  const service = filters.service?.alias;
  const location = filters.location?.alias;
  const customerType = CUSTOMER_TYPE_TO_ROUTE[filters.customerType];

  const helper = getOrganizationHelpers(filters.organizationType);
  const organizationTypeUrl = helper.listTypeUrl;

  return {
    ...filters,
    ...(filters[FILTERS_NAME.Location] && { [FILTERS_NAME.Location]: location }),
    ...(filters[FILTERS_NAME.CustomerType] && { [FILTERS_NAME.CustomerType]: customerType }),
    ...(service && { [FILTERS_NAME.Service]: service }),
    orgType: organizationTypeUrl,
  };
};
